import { render, staticRenderFns } from "./RelatedButtons.vue?vue&type=template&id=b12c5f2c&scoped=true&"
import script from "./RelatedButtons.vue?vue&type=script&lang=js&"
export * from "./RelatedButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12c5f2c",
  null
  
)

export default component.exports